<template>
  <div class="questions-container">
    <div
      class="back-button-container"
      aria-label="Go back"
      @click="$emit('prev-step')"
    >
      <div class="back-button">
        <svg
          class="arrow"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <line
            x1="19"
            y1="12"
            x2="5"
            y2="12"
          />
          <polyline points="12 19 5 12 12 5" />
        </svg>
      </div>
      <span class="back-text">Back</span>
    </div>

    <img
      src="../assets/logo.png"
      class="logo-questions"
      alt="ICMSS 2021"
      @click="goToSplash"
    >

    <div
      v-if="questions.length > 0"
      class="main-content"
      @touchstart="handleTouchStart"
      @touchmove="handleTouchMove"
      @touchend="handleTouchEnd"
    >
      <div class="question-wrapper">
        <p class="question-counter is-size-5-mobile">
          Question {{ index + 1 }} of {{ questions.length }}
        </p>

        <transition
          :name="transitionDirection === 'next' ? 'slide-left' : 'slide-right'"
          mode="out-in"
        >
          <p
            :key="index"
            class="question-title is-size-4-mobile"
          >
            {{ title }}
          </p>
        </transition>

        <div class="range-wrapper">
          <span class="range-label left-label">Disagree</span>
          <div class="radio-buttons">
            <label
              v-for="val in [1, 2, 3, 4, 5]"
              :id="'val-'.concat(val)"
              :key="val"
              class="radio-styled-container"
              @click="blurInput"
            >
              <input
                v-model="answer"
                type="radio"
                :value="val"
              >
              <span class="radio-styled" />
            </label>
          </div>
          <span class="range-label right-label">Agree</span>
        </div>
        
        <div class="mobile-labels">
          <span class="mobile-label mobile-disagree">Disagree</span>
          <span class="mobile-label mobile-agree">Agree</span>
        </div>
      </div>

      <div class="navigation-buttons">
        <button
          v-if="!first"
          class="nav-button prev-nav-button"
          @click="idxPrev"
        >
          <svg
            class="arrow-icon"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <line
              x1="19"
              y1="12"
              x2="5"
              y2="12"
            />
            <polyline points="12 19 5 12 12 5" />
          </svg>
          <span class="button-text">Previous</span>
        </button>

        <button
          v-if="!last"
          class="nav-button next-nav-button"
          @click="idxNext"
        >
          <span class="button-text">Next</span>
          <svg
            class="arrow-icon"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <line
              x1="5"
              y1="12"
              x2="19"
              y2="12"
            />
            <polyline points="12 5 19 12 12 19" />
          </svg>
        </button>

        <button
          v-if="last"
          class="nav-button next-nav-button finish-button"
          @click="submit"
        >
          <span class="button-text">Finish</span>
          <svg
            class="arrow-icon"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <line
              x1="5"
              y1="12"
              x2="19"
              y2="12"
            />
            <polyline points="12 5 19 12 12 19" />
          </svg>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import data from "../questions.json";

export default {
  name: "Questions",
  props: {
    swipe: {
      type: String,
      default: "none",
    },
  },
  data() {
    return {
      index: 0,
      questions: [],
      answers: [],
      answer: 3,

      isTransitioning: false,
      transitionDirection: 'next',

      touchStartX: 0,
      touchStartY: 0,
      touchEndX: 0,
      touchEndY: 0,
      minSwipeDistance: 50,
    };
  },
  computed: {
    title() {
      return this.questions[this.index];
    },
    last() {
      return this.index === this.questions.length - 1;
    },
    first() {
      return this.index === 0;
    },
  },
  watch: {
    swipe(val) {
      if (val === "top") this.idxNext();
      else if (val === "bottom") this.idxPrev();
      this.$emit("swiped");
    },
  },
  async mounted() {
    try {
      this.questions = data.questions;
    } catch (error) {
      console.error(error);
    }
    document.addEventListener("keyup", this.handleKey);
  },
  beforeDestroy() {
    document.removeEventListener("keyup", this.handleKey);
  },
  methods: {
    handleKey(event) {
      if (event.keyCode == 38) this.idxPrev();
      else if (event.keyCode == 40) this.idxNext();
    },
    blurInput(e) {
      e.target.blur();
    },

    handleTouchStart(event) {
      this.touchStartX = event.touches[0].clientX;
      this.touchStartY = event.touches[0].clientY;
    },
    handleTouchMove(event) {
      if (Math.abs(event.touches[0].clientX - this.touchStartX) > 10) {
        event.preventDefault();
      }
    },
    handleTouchEnd(event) {
      this.touchEndX = event.changedTouches[0].clientX;
      this.touchEndY = event.changedTouches[0].clientY;
      this.handleSwipe();
    },
    handleSwipe() {
      const deltaX = this.touchEndX - this.touchStartX;
      const deltaY = this.touchEndY - this.touchStartY;
      
      if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > this.minSwipeDistance) {
        if (deltaX > 0) {
          this.idxPrev();
        } else {
          this.idxNext();
        }
      }
    },

    idxNext() {
      if (!this.last) {
        this.answers[this.index] = this.answer;
        this.isTransitioning = true;
        this.transitionDirection = 'next';
        setTimeout(() => {
          this.index += 1;
          this.answer = this.answers[this.index] || 3;
          this.isTransitioning = false;
        });
      }
    },
    idxPrev() {
      if (!this.first) {
        this.answers[this.index] = this.answer;
        this.isTransitioning = true;
        this.transitionDirection = 'prev';
        setTimeout(() => {
          this.index -= 1;
          this.answer = this.answers[this.index] || 3;
          this.isTransitioning = false;
        });
      }
    },
    async submit() {
      this.answers[this.index] = this.answer;
      this.$emit("next-step", { answers: this.answers });
    },
    goToSplash() {
      // Navigate back to splash screen (step 0)
      this.$emit("go-to-splash");
    },
  },
};
</script>

<style scoped>
.questions-container {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
}

.main-content {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
  touch-action: pan-y;
}

.back-button-container {
  position: fixed;
  top: 40px;
  left: 40px;
  display: flex;
  align-items: center;
  cursor: pointer;
  z-index: 100;
}

.back-button {
  width: 50px;
  height: 50px;
  background-color: rgba(255, 255, 255, 0.15);
  border: 1px solid white;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: background-color 0.3s ease, transform 0.3s ease;
}

.back-button .arrow {
  width: 24px;
  height: 24px;
  stroke: white;
  stroke-width: 2.5;
  transition: stroke 0.3s ease;
}

.back-text {
  color: white;
  font-size: 1.2rem;
  margin-left: 10px;
  opacity: 0;
  transition: opacity 0.3s ease, transform 0.3s ease;
  transform: translateX(-10px);
}

.back-button-container:hover .back-button {
  background-color: white;
  transform: scale(1.1);
}

.back-button-container:hover .arrow {
  stroke: #000942;
}

.back-button-container:hover .back-text {
  opacity: 1;
  transform: translateX(0);
}

.question-wrapper {
  width: 100%;
  min-height: 60vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2rem;
  padding: 3rem 0;
  box-sizing: border-box;
}

.question-counter {
  color: rgba(255, 255, 255, 0.8);
  font-family: "Montserrat", sans-serif;
  font-weight: bold;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.7);
}

.question-title {
  text-align: center;
  width: 100%;
  min-height: 120px;
  margin: 0 auto;
  font-family: "Montserrat", sans-serif;
  font-size: 38px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1.2;
  left: 0;
  right: 0;
  padding: 0 10%;
}

.slide-left-enter-active,
.slide-left-leave-active,
.slide-right-enter-active,
.slide-right-leave-active {
  transition: all 0.5s ease;
}

.slide-left-enter {
  transform: translateX(100%);
  opacity: 0;
}

.slide-left-leave-to {
  transform: translateX(-100%);
  opacity: 0;
}

.slide-right-enter {
  transform: translateX(-100%);
  opacity: 0;
}

.slide-right-leave-to {
  transform: translateX(100%);
  opacity: 0;
}

.navigation-buttons {
  position: fixed;
  bottom: 100px;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
  padding: 0 40px;
  z-index: 10;
}

.nav-button {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 15px 25px;
  background-color: rgba(255, 255, 255, 0.15);
  border: 1px solid white;
  border-radius: 50px;
  color: white;
  font-family: "Montserrat", sans-serif;
  font-size: 18px;
  font-weight: bold;
  text-transform: uppercase;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
  cursor: pointer;
}

.nav-button:hover {
  background-color: white;
  color: #000942;
  transform: scale(1.05);
}

.nav-button .arrow-icon {
  width: 20px;
  height: 20px;
  stroke: currentColor;
  stroke-width: 2.5;
  transition: transform 0.3s ease;
}

.prev-nav-button {
  margin-right: auto;
}

.next-nav-button {
  margin-left: auto;
}

.prev-button:hover .arrow-icon {
  transform: translateX(-3px);
}

.next-nav-button:hover .arrow-icon {
  transform: translateX(3px);
}

.finish-button {
  background: linear-gradient(to bottom right, #B27E37, #D5B13D);
  border: 1px solid transparent;
  border-radius: 50px;
  position: relative;
  z-index: 1;
}

.finish-button .button-text {
  color: white !important;
}

.finish-button .arrow-icon {
  stroke: white !important;
}

.finish-button:hover {
  background: linear-gradient(to bottom right, #D5B13D, #B27E37) !important;
  color: white !important;
  transform: scale(1.05);
}

.finish-button:hover .button-text {
  color: white !important;
}

.finish-button:hover .arrow-icon {
  stroke: white !important;
  transform: translateX(3px);
}

.range-wrapper {
  width: 70%;
  min-height: 150px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 auto;
  padding: 2rem 0;
  box-sizing: border-box;
}

.range-label {
  color: white;
  font-family: "Montserrat", sans-serif;
  font-size: 20px;
  font-weight: bold;
  text-transform: uppercase;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.7);
  white-space: nowrap;
}

.left-label {
  margin-right: 2rem;
}

.right-label {
  margin-left: 2rem;
}

.radio-buttons {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.radio-styled-container {
  display: block; 
  cursor: pointer; 
  position: relative; 
  height: 100px; 
  width: 100px; 
  user-select: none;
}

#val-2, #val-4 { 
  transform: scale(0.8); 
}

#val-3 { 
  transform: scale(0.6); 
}

.radio-styled-container input { 
  position: absolute; 
  opacity: 0; 
  cursor: pointer; 
}

.radio-styled {
  position: absolute; 
  top: 0; 
  left: 0; 
  height: 100%; 
  width: 100%; 
  background-color: transparent; 
  border: 6px solid #fff; 
  border-radius: 50%; 
  transition: 0.2s all;
}

#val-2 .radio-styled, #val-4 .radio-styled { 
  border: 7px solid #fff; 
}

#val-3 .radio-styled { 
  border: 8px solid #fff; 
}

.radio-styled-container:hover input ~ .radio-styled, 
.radio-styled-container input:checked ~ .radio-styled { 
  background-color: #fff; 
}

.mobile-labels {
  display: none;
}

@media screen and (max-width: 991px) {
  .back-button-container {
    top: 20px;
    left: 20px;
  }
  
  .back-button {
    width: 45px;
    height: 45px;
    background-color: white;
  }
  
  .back-button .arrow {
    stroke: #000942;
    transform: rotate(0deg);
  }
  
  .back-text {
    opacity: 1;
    transform: translateX(0);
    color: white;
  }

  .question-wrapper {
    width: 100%;
    padding: 0.5rem;
    gap: 3rem;
  }

  .question-title { 
    width: 95%; 
    font-size: 24px;
    height: 120px;
    padding: 0 5%;
    line-height: 1.3;
  }

  .range-wrapper { 
    width: 95%;
    min-height: 120px;
    justify-content: center;
    gap: 1rem;
    padding: 1rem 0;
  }

  .range-label {
    display: none;
  }

  .mobile-labels {
    display: flex;
    justify-content: space-between;
    width: 95%;
    margin-top: -1rem;
  }

  .mobile-label {
    color: white;
    font-family: "Montserrat", sans-serif;
    font-size: 16px;
    font-weight: bold;
    text-transform: uppercase;
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.7);
  }

  .navigation-buttons {
    bottom: 80px;
    padding: 0 20px;
  }

  .nav-button {
    padding: 12px 20px;
    font-size: 14px;
    gap: 8px;
  }

  .nav-button .arrow-icon {
    width: 16px;
    height: 16px;
  }
}

@media screen and (max-width: 768px) {
  .navigation-buttons {
    bottom: 60px;
    padding: 0 15px;
  }

  .nav-button {
    padding: 10px 18px;
    font-size: 13px;
  }
}

@media screen and (max-width: 480px) {
  .question-title {
    font-size: 20px;
    min-height: 60px;
  }

  .range-wrapper {
    width: 100%;
    padding: 0.5rem 0;
  }

  .radio-styled-container {
    height: 50px;
    width: 50px;
  }

  .radio-buttons {
    gap: 0.3rem;
  }

  .range-label {
    font-size: 14px;
  }

  .navigation-buttons {
    bottom: 50px;
    padding: 0 10px;
  }

  .nav-button {
    padding: 10px 15px;
    font-size: 12px;
  }
}

@media screen and (max-height: 500px) and (orientation: landscape) {
  .navigation-buttons {
    bottom: 30px;
    padding: 0 15px;
  }

  .nav-button {
    padding: 8px 15px;
    font-size: 12px;
  }

  .question-wrapper {
    margin-top: 5rem;
  }
}

@media screen and (min-width: 768px) and (max-width: 991px) {
  .navigation-buttons {
    bottom: 70px;
    padding: 0 30px;
  }
}
</style>

<style scoped>
.logo-questions {
  position: fixed;
  top: 35px;
  right: 5%;
  width: auto;
  max-height: 10vh;
  z-index: 100;
  cursor: pointer;
}

@media screen and (max-width: 991px) {
  .logo-questions {
    top: 20px;
    right: 20px;
    max-height: 8vh;
  }
}

@media screen and (max-width: 768px) {
  .logo-questions {
    top: 15px;
    right: 15px;
    max-height: 7vh;
  }
}

@media screen and (max-width: 480px) {
  .logo-questions {
    top: 10px;
    right: 10px;
    max-height: 6vh;
  }
}
</style>
